/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandStocktwits = createReactComponent("brand-stocktwits", "IconBrandStocktwits", [
  ["path", { d: "M16 3l-8 4.5l8 4.5", key: "svg-0" }],
  ["path", { d: "M8 12l8 4.5l-8 4.5", key: "svg-1" }]
]);

export { IconBrandStocktwits as default };
//# sourceMappingURL=IconBrandStocktwits.js.map
